import { PostCheckoutAuthSignInTrigger, TriggerHandler } from "../types";

export const authSignInHandler: TriggerHandler<PostCheckoutAuthSignInTrigger> = async (
  _api,
  context,
  _trigger,
) => {
  const { firstOrder } = context.sources;

  if (!firstOrder?.authData) {
    return false;
  }

  const { accessToken, refreshToken } = firstOrder.authData;

  if (accessToken && refreshToken) {
    await context.auth.forceLogin({
      access_token: accessToken,
      refresh_token: refreshToken,
      expires_in: firstOrder.authData.expiresIn,
      token_type: "Bearer",
    }, true);
    return true;
  }

  return false;
};
